(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin/rich-text/assets/javascripts/helpers/parse-editor-state.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin/rich-text/assets/javascripts/helpers/parse-editor-state.js');

'use strict';

const {
  RichTextState,
  convertDraftToLexical,
  isDraftFormat,
  isCompactStorage,
  parseCompactStorage
} = svs.components.marketplaceRetailAdmin.richText.helpers;
function parseEditorState(editorJson) {
  if (editorJson instanceof RichTextState) {
    return editorJson;
  }
  if (isCompactStorage(editorJson)) {
    return parseCompactStorage(editorJson);
  }
  try {
    const parsed = JSON.parse(editorJson);
    if (isDraftFormat(parsed)) {
      const lexicalState = convertDraftToLexical(parsed);
      return new RichTextState(JSON.stringify(lexicalState));
    }

    if (parsed.root) {
      return new RichTextState(editorJson);
    }
    return RichTextState.createEmpty();
  } catch (e) {
    return RichTextState.createEmpty();
  }
}
setGlobal('svs.components.marketplaceRetailAdmin.richText.helpers.parseEditorState', parseEditorState);

 })(window);